import { render, staticRenderFns } from "./crmBlock.vue?vue&type=template&id=0e3ec59d&scoped=true&functional=true&"
import script from "./crmBlock.vue?vue&type=script&lang=js&"
export * from "./crmBlock.vue?vue&type=script&lang=js&"
import style0 from "./crmBlock.vue?vue&type=style&index=0&id=0e3ec59d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0e3ec59d",
  null
  
)

export default component.exports